import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import HistoryIcon from '@mui/icons-material/History';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import ChecklistIcon from '@mui/icons-material/Checklist';
import StyleIcon from '@mui/icons-material/Style';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import ShortTextIcon from '@mui/icons-material/ShortText';
import ForumIcon from '@mui/icons-material/Forum';

interface LearningModeIconProps {
  name: string;
  size?: number;
}

const MAP: Record<string, React.FC<{ sx?: { fontSize?: number } }>> = {
  AutoAwesome: AutoAwesomeIcon as React.FC<{ sx?: { fontSize?: number } }>,
  History: HistoryIcon as React.FC<{ sx?: { fontSize?: number } }>,
  Shuffle: ShuffleIcon as React.FC<{ sx?: { fontSize?: number } }>,
  Checklist: ChecklistIcon as React.FC<{ sx?: { fontSize?: number } }>,
  Style: StyleIcon as React.FC<{ sx?: { fontSize?: number } }>,
  SyncAlt: SyncAltIcon as React.FC<{ sx?: { fontSize?: number } }>,
  ShortText: ShortTextIcon as React.FC<{ sx?: { fontSize?: number } }>,
  Forum: ForumIcon as React.FC<{ sx?: { fontSize?: number } }>,
};

const LearningModeIcon: React.FC<LearningModeIconProps> = ({
  name,
  size = 23,
}) => {
  const Icon = MAP[name];
  if (!Icon) return null;
  return <Icon sx={{ fontSize: size }} />;
};

export default LearningModeIcon;
